

import React from 'react';

type SvgProps = {
    color: string;
    size?: number;
};

const Sun: React.FC<SvgProps> = ({ color, size }) => (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 19H10V21H3V19Z" fill={color} />
        <path d="M31 19H38V21H31V19Z" fill={color} />
        <path d="M19.5 37.5V30.5H21.5V37.5H19.5Z" fill={color} />
        <path d="M19.5 10V3H21.5V10H19.5Z" fill={color} />
        <path d="M28.6348 26.7207L33.5817 31.6677L32.1675 33.0819L27.2206 28.1349L28.6348 26.7207Z" fill={color} />
        <path d="M8.83301 6.91895L13.7828 11.8687L12.3685 13.2829L7.41879 8.33316L8.83301 6.91895Z" fill={color} />
        <path d="M27.21 11.876L32.1682 6.91777L33.5824 8.33198L28.6242 13.2902L27.21 11.876Z" fill={color} />
        <path d="M7.41895 31.667L12.3711 26.7148L13.7853 28.1291L8.83316 33.0812L7.41895 31.667Z" fill={color} />
        <circle cx="20.3962" cy="20.3961" r="8.39594" fill={color} />
    </svg>

);

export default Sun;